"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarComboBoxFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarComboBoxFilter");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var BonusFreeSpinRangeGameSetsList = /** @class */ (function (_super) {
    __extends(BonusFreeSpinRangeGameSetsList, _super);
    function BonusFreeSpinRangeGameSetsList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchTitleInput = null;
        _this.state = {
            data: [],
            loading: true,
            totalRows: 0,
            searchTitleFilter: [],
            searchTitleValue: ""
        };
        return _this;
    }
    BonusFreeSpinRangeGameSetsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                loading: false
            });
        });
        this.props.data.LoadData(this.props.record.key, this.props.allCurrency, this.props.currencyId);
        this.props.state.setExtBreadCrumbPath(["\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043D\u0430\u0431\u043E\u0440\u0430 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0430 \u0444\u0440\u0438\u0441\u043F\u0438\u043D\u043E\u0432"]);
    };
    BonusFreeSpinRangeGameSetsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BonusFreeSpinRangeGameSetsList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            if (nextProps.record.key != this.props.record.key) {
                nextProps.data.LoadData(nextProps.record.key, nextProps.allCurrency, nextProps.currencyId);
            }
        }
    };
    BonusFreeSpinRangeGameSetsList.prototype.getColumns = function () {
        var _this = this;
        return [{
                title: 'Сумма депозита',
                dataIndex: this.props.data.dk_min_dep_amount,
                key: this.props.data.dk_min_dep_amount,
                width: 200,
                sorter: function (a, b) { return a.min_dep_amount - b.min_dep_amount; },
                render: function (text, record, idx) { return (React.createElement("div", null, record.min_dep_amount.toFixed(2))); }
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_iso,
                key: this.props.data.dk_app_currency_iso,
                width: 100,
            }, {
                title: 'Набор игр',
                dataIndex: this.props.data.dk_gameset_title,
                key: this.props.data.dk_gameset_title,
                width: 200,
            }, {
                title: 'Описание',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 300,
            }, {
                title: 'Добавлен',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.props.state.getDateTimeFormat())));
                },
                width: 150,
            }, {
                title: 'Изменен',
                dataIndex: this.props.data.dk_date_changed,
                key: this.props.data.dk_date_changed,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed.format(_this.props.state.getDateTimeFormat())));
                },
                width: 150,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditActionClick(record); } }))); },
                width: 100
            }];
    };
    BonusFreeSpinRangeGameSetsList.prototype.onEditActionClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BonusFreeSpinRangeGameSetsList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.setState({ loading: true }, function () {
                _this.props.data.LoadData(_this.props.record.key, _this.props.allCurrency, _this.props.currencyId);
            });
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    BonusFreeSpinRangeGameSetsList.prototype.onCurrencyFilterChanged = function (allCurrencies, CurrencyId) {
        var _this = this;
        this.props.data.LoadData(this.props.record.key, allCurrencies, CurrencyId, function () {
            if (_this.props.onCurrencyFilterChanged) {
                _this.props.onCurrencyFilterChanged(allCurrencies, CurrencyId);
            }
        });
    };
    BonusFreeSpinRangeGameSetsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Вернуться", refresh: "Обновить", create: "Создать" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarComboBoxFilter_1.default, { allItems: this.props.allCurrency, availItems: this.props.availCurrency, captions: { checkbox: "Все валюты", placeholder: "Выберите валюту" }, selectedItem: this.props.currencyId, onFilterChanged: this.onCurrencyFilterChanged.bind(this), width: "100%" })),
            React.createElement(antd_1.Table, { rowKey: "key", locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, loading: this.state.loading, pagination: {
                    defaultPageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 :  ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return (React.createElement("div", { key: "t_1", style: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", flexWrap: "nowrap" } },
                    React.createElement("div", { key: "c_1" },
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "]"))); }, scroll: { x: true } })));
    };
    return BonusFreeSpinRangeGameSetsList;
}(React.Component));
exports.default = BonusFreeSpinRangeGameSetsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_fsranges/ui/component/BonusFreeSpinRangeGameSetsList.tsx
// module id = 2493
// module chunks = 0